<template>
  <div>
    <el-row>
      <el-col
        v-for="(item, index) in baseInfo"
        :key="item.value + index"
        :span="item.row"
      >
        <div class="info-item" v-if="item.isShow">
          <span class="label">{{ item.label }}:</span>
          <span v-if="item.label === '收货人信息'">
            {{ receiverInfo }}
          </span>
          <span v-else-if="item.label === '开票约定'">
            交易结束后{{ detailInformation["invoiceAgreement"] }}日
          </span>
          <span v-else-if="detailInformation[item.value] !== undefined">
            {{
              item.type
                ? findInformation(item.type, detailInformation[item.value])
                : formatChange(item.format, detailInformation[item.value])
            }}
          </span>
          <span v-else>-</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "detailShow",
  props: {
    baseInfo: {
      type: Array,
      default: () => []
    },
    detailInformation: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    receiverInfo() {
      const {
        receiverName,
        receiverMobileNumber,
        receiverCountryName,
        receiverProvinceName,
        receiverCityName,
        receiverCountyName,
        receiverTown,
        receiverAddress
      } = this.detailInformation;
      return `${receiverName || ""} ${receiverMobileNumber ||
        ""} ${receiverCountryName || ""} ${receiverProvinceName ||
        ""} ${receiverCityName || ""} ${receiverCountyName ||
        ""} ${receiverTown || ""} ${receiverAddress || ""}`.trim();
    }
  },
  data() {
    return {
      optionsLists: {
        paymentMethod: [
          { value: 1, label: "货到付款" },
          { value: 2, label: "分期付款" }
        ],
        invoiceType: [
          { value: 1, label: "增值税电子普票" },
          { value: 2, label: "纸质普票" },
          { value: 3, label: "纸质专票" },
          { value: 4, label: "增值税电子专票" }
        ],
        transportationMethod: [
          { value: 1, label: "购方自提" },
          { value: 2, label: "供方承运" },
          { value: 3, label: "双方协商" }
        ],
        deliveryMethod: [
          { value: 1, label: "工厂交货" },
          { value: 2, label: "货交承运人" },
          { value: 3, label: "目的地交货" }
        ],
        deliveryTime: [
          { value: 0, label: "不限" },
          { value: 1, label: "工作日配送" }
        ],
        sourceSystem: [
          { value: 1, label: "租赁" },
          { value: 2, label: "二级集采" }
        ],
        purchaseMethod: [
          { value: "1", label: "邀请询价" },
          { value: "7", label: "公开询价" }
        ],
        inquiryMode: [
          { value: "1", label: "固定价" },
          { value: "2", label: "浮动价" },
          { value: "3", label: "基准价" }
        ],
        pricingDate: [
          { value: "1", label: "计划日" },
          { value: "2", label: "发货日" },
          { value: "3", label: "到货日" }
        ]
      }
    };
  },
  created() {},
  methods: {
    findInformation(type, value) {
      const arr = this.optionsLists[type] || [];
      const item = arr.find(item => item.value === value);
      return item ? item.label : "-";
    },
    formatChange(format, value) {
      if (format) {
        if (format === "time") {
          if (value) return value.substring(0, 10);
        } else if (format === "number") {
          if (value) return value.toFixed(2);
        }
      } else {
        return value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info-item {
  display: flex;
  //align-items: center;  // 保证垂直方向上对齐
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 20px;
  word-wrap: break-word; // 自动换行，防止文本内容挤压
}

.label {
  display: inline-block;
  width: 110px; // 固定宽度
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0; // 防止label被压缩
}

.info-item > span {
  white-space: normal; // 允许文本换行
  word-wrap: break-word; // 遇到长单词时进行换行
  overflow-wrap: break-word; // 同样处理单词溢出
  word-break: break-all; // 防止长单词在容器之外溢出，尽量拆分长单词
  text-overflow: ellipsis; // 当文本超出时显示省略号（可选）
  overflow: hidden; // 防止溢出
}
/deep/.el-col-24 {
  width: 85% !important;
}
</style>
